import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8787cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-kt-drawer-width"]
const _hoisted_2 = { class: "card shadow-none rounded-0 w-100 bg-light" }
const _hoisted_3 = { class: "card m-3" }
const _hoisted_4 = { class: "card-toolbar d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-expand-arrows-alt fs-3 me-4 text-black-50" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-color-primary m-3",
  id: "kt_lookup_drawer_close"
}, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-times fs-3 me-4 text-black-50" })
  ])
], -1))
const _hoisted_8 = {
  class: "card-header",
  id: "kt_lookup_drawer_header"
}
const _hoisted_9 = { class: "card-title fw-bolder text-gray-700" }
const _hoisted_10 = { class: "symbol symbol-circle me-5" }
const _hoisted_11 = { class: "symbol-label border border-primary border-dashed" }
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = { class: "px-10" }
const _hoisted_14 = { class: "nav nav-tabs nav-line-tabs nav-line-tabs-2x mt-5 fs-5" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  class: "nav-link active el-tabs__item is-top is-active",
  "data-bs-toggle": "tab",
  href: "#kt_tab_LKDetails"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-signpost-2 me-2 fs-4 text-primary" }, null, -1))
const _hoisted_18 = { class: "m-3" }
const _hoisted_19 = { class: "text-truncate" }
const _hoisted_20 = { class: "text-truncate" }
const _hoisted_21 = { class: "text-truncate" }
const _hoisted_22 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_lookup_drawer",
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "explore",
    "data-kt-drawer-activate": "true",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": _ctx.currentWidth,
    "data-kt-drawer-direction": "end",
    "data-kt-drawer-toggle": "#kt_lookup_drawer_toggle-activity",
    "data-kt-drawer-close": "#kt_lookup_drawer_close"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-icon btn-active-color-primary m-3",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleResize && _ctx.handleResize(...args)))
          }, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("i", {
                  width: "16",
                  height: "16",
                  style: {"color":"#009ef7"},
                  class: _normalizeClass(_ctx.icon)
                }, null, 2)
              ])
            ]),
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.viewName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", _hoisted_15, [
              _createElementVNode("a", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.activity")), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          total: _ctx.localPagination.total,
          rowsPerPage: _ctx.rowsPerPage,
          page: _ctx.localPagination.page,
          loading: _ctx.loading,
          showSearch: _ctx.showSearch,
          tableFilter: _ctx.tableFilter,
          viewName: "roleActivity",
          onQueryUpdate: _ctx.syncQuery
        }, {
          "cell-createdDate": _withCtx(({ row: user }) => [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.format.DateTime(user.createdDate)), 1)
          ]),
          "cell-createdBy": _withCtx(({ row: user }) => [
            _createElementVNode("span", _hoisted_20, _toDisplayString(user.createdBy), 1)
          ]),
          "cell-typeCodeText": _withCtx(({ row: user }) => [
            _createElementVNode("span", _hoisted_21, _toDisplayString(user.typeCodeText), 1)
          ]),
          "cell-descriptions": _withCtx(({ row: user }) => [
            _createElementVNode("span", {
              class: "text-truncate",
              title: _ctx.format.convertUTCToLocal(user.description)
            }, _toDisplayString(_ctx.format.convertUTCToLocal(user.description)), 9, _hoisted_22)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "tableFilter", "onQueryUpdate"])
      ])
    ])
  ], 8, _hoisted_1))
}